import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const result = await loginWithGoogle(sessionId);
        window.history.replaceState(null, '', window.location.pathname);
        if (result?.pending) {
          navigate('/pending-approval', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (err) {
        console.error('Google auth error:', err);
        setError('Authentication failed. Please try again.');
        setTimeout(() => navigate('/login'), 2000);
      }
    })();
  }, [loginWithGoogle, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-airbnb-light-gray">
        <div className="text-center">
          <p className="text-red-500 mb-2">{error}</p>
          <p className="text-airbnb-medium-gray text-sm">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-airbnb-light-gray">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-airbnb-pink animate-spin mx-auto mb-4" />
        <p className="text-airbnb-gray font-medium">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
